@use 'sass:math';

$bg-color: #34495e;
$default-size: 1em;
$label-font-size: math.div($default-size, 4);
$label-font-size-redo: $default-size * 4;

// -- mixins
@mixin size($width, $height) {
  height: $height;
  width: $width;
}

@mixin draw-progress($progress, $color) {
  $rotation: $progress * 3.6;

  @keyframes progress-animation-1 {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate($rotation);
    }
  }

  @keyframes progress-animation-2 {
    0% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate($rotation + 180);
    }
  }

  .pie {
    .half-circle {
      border-color: $color;
    }

    .left-side {
      transform: rotate(#{$rotation}deg);
      animation: progress-animation-1 0.5s ease-in;
    }

    @if $progress <= 50 {
      .right-side {
        display: none;
      }
    } @else {
      clip: rect(auto, auto, auto, auto);

      .right-side {
        transform: rotate(180deg);
      }

      .left-side {
        animation: progress-animation-2 0.5s ease-in;
      }
    }
  }
}

// -- selectors

.circular-progress-bar {
  // background: #ecf0f1;
  font-family: 'Lato';
}

.set-size {
  font-size: 10em;
}

.pie-wrapper {
  @include size($default-size, $default-size);
  // float: left;
  margin: 15px;
  position: relative;

  &:nth-child(3n + 1) {
    clear: both;
  }

  .pie {
    @include size(100%, 100%);
    clip: rect(0, $default-size, $default-size, math.div($default-size, 2));
    left: 0;
    position: absolute;
    top: 0;

    .half-circle {
      @include size(100%, 100%);
      border: ( math.div($default-size, 10)) solid #3498db;
      border-radius: 50%;
      clip: rect(0, math.div($default-size, 2), $default-size, 0);
      left: 0;
      position: absolute;
      top: 0;
    }
  }

  .circular-progress-label {
    background: $bg-color;
    border-radius: 50%;
    bottom: math.div($label-font-size-redo, 10);
    color: #ecf0f1;
    cursor: default;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    left: math.div($label-font-size-redo, 10);
    position: absolute;
    right: math.div($label-font-size-redo, 10);
    text-align: center;
    top: math.div($label-font-size-redo, 10);

    .info {
      .upper-text {
        font-size: 14px;
        font-weight: 400;
        color: black;
        margin: 0;
        padding: 0;
      }

      .lower-text {
        font-size: 24px;
        font-weight: 700;
        color: black;
        margin: 0;
        padding: 0;
      }

      .icon {
        color: var(--action-default);
      }
    }

    &::before {
      display: none;
    }
  }

  .shadow {
    @include size(100%, 100%);
    border: math.div($default-size, 10) solid rgba(171, 171, 171, 0.2);
    border-radius: 50%;
  }

  &.style-2 {
    .circular-progress-label {
      background: none;
      color: #7f8c8d;
    }
  }

  @for $i from 1 through 100 {
    $progress: $i * 1;
    &.progress-#{$i} {
      @include draw-progress($progress, var(--action-default));
    }
  }
}